import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const selectors = [
  ":is(figure, img, svg, video, iframe):not(.background-image)",
  ":is(h1, h2, h3, h4, h5, h6, p, li, a:not(.edit))",
  ":is(blockquote, form, table, details)",
  ":is(.button, .breadcrumbs, .card, .pagination)",
].join(", ");

// Viewport detection functions
function isInViewport(targets) {
  const viewportHeight =
    window.innerHeight || document.documentElement.clientHeight;

  return targets.filter((el) => {
    const rect = el.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < viewportHeight * 0.9;
  });
}

function isAboveViewport(targets) {
  return targets.filter((el) => {
    const rect = el.getBoundingClientRect();
    return rect.bottom <= 0;
  });
}

// Set the initial state of targets that are above the viewport
// to be visible and in their final position.
function showAboveViewportTargets(targets) {
  const aboveViewportTargets = isAboveViewport(targets);
  if (!aboveViewportTargets.length) return;

  gsap.set(aboveViewportTargets, {
    autoAlpha: 1,
    y: 0,
  });
}

// Animate targets that are currently in the viewport on page load
function animateViewportTargets(targets) {
  const viewportTargets = isInViewport(targets);
  if (!viewportTargets.length) return;

  gsap.to(viewportTargets, {
    autoAlpha: 1,
    y: 0,
    stagger: 0.12,
    duration: 0.7,
    ease: "power2.out",
  });
}

// Animate the remaining targets as they enter the viewport on scroll
function animateScrollTargets(targets) {
  const scrollTargets = targets;
  if (!scrollTargets.length) return;

  ScrollTrigger.batch(scrollTargets, {
    start: "top 90%",
    onEnter: (batch) =>
      gsap.to(batch, {
        autoAlpha: 1,
        y: 0,
        stagger: 0.12,
        duration: 0.7,
        ease: "power2.out",
      }),
    onLeaveBack: (batch) =>
      gsap.to(batch, {
        autoAlpha: 0,
        y: 24,
        stagger: 0.12,
        duration: 0.7,
        ease: "power2.out",
      }),
  });
}

function initAnimateOnScroll() {
  // Get all animation targets, filtering out any that
  // are nested inside other targets.
  const targets = gsap.utils
    .toArray(document.querySelector("main").querySelectorAll(selectors))
    .filter((el) => !el.parentElement?.closest(selectors));
  if (!targets.length) return;

  // Set initial state for all targets
  gsap.set(targets, {
    autoAlpha: 0,
    y: 24,
  });

  showAboveViewportTargets(targets);
  animateViewportTargets(targets);
  animateScrollTargets(targets);

  ScrollTrigger.refresh();
}

export default initAnimateOnScroll;
